var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 0C5.808 0 0 5.8077 0 13c0 7.1921 5.8079 13 13 13 7.1922 0 13-5.8079 13-13 0-7.1922-5.8078-13-13-13zM9.2084 19.5h-3.25v-9.2084h3.25V19.5zM7.5834 8.6666h-.0301c-1.294 0-2.1366-.8426-2.1366-1.8958 0-1.0834.8727-1.8959 2.1667-1.8959 1.324 0 2.1365.8125 2.1666 1.8959 0 1.0532-.8426 1.8958-2.1666 1.8958zM21.125 19.5h-3.25v-4.875c0-1.6551-.662-2.1667-1.6552-2.1667-.993 0-1.5949.8426-1.5949 2.1667V19.5h-3.25v-7.0417s-.0602-1.8056-.0902-2.1667h3.2199l.1203 1.4144c.4213-1.1736 1.3843-1.956 2.7084-1.956 2.3171 0 3.7917 1.8958 3.7917 4.875V19.5z"}));
}

Linkedin.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
